let suppressEscapeUntil = 0;

export function suppressEscapeFor(ms = 150) {
  suppressEscapeUntil = Date.now() + ms;
}

export function shouldSuppressEscape() {
  return Date.now() <= suppressEscapeUntil;
}
